export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["AUTHORIZED"] = "AUTHORIZED";
    PaymentStatus["SETTLED"] = "SETTLED";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["REVERSE_REQUESTED"] = "REVERSE_REQUESTED";
    PaymentStatus["PARTIAL_REVERSE_REQUESTED"] = "PARTIAL_REVERSE_REQUESTED";
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["DISPUTED"] = "DISPUTED";
    PaymentStatus["CHARGEBACK"] = "CHARGEBACK";
    PaymentStatus["NSF"] = "NSF";
    PaymentStatus["CAPTURE_FAILED"] = "CAPTURE_FAILED";
    PaymentStatus["REFUND_FAILED"] = "REFUND_FAILED";
    PaymentStatus["CAPTURE_ATTEMPTS_EXCEEDED"] = "CAPTURE_ATTEMPTS_EXCEEDED";
})(PaymentStatus || (PaymentStatus = {}));
//# sourceMappingURL=PaymentStatus.js.map